import {
    Component,
    Input,
    OnInit,
    OnChanges,
    OnDestroy,
    SimpleChanges,
    ChangeDetectorRef,
    ChangeDetectionStrategy,
} from '@angular/core';

import { AngularFireDatabase, AngularFireAction } from 'angularfire2/database';
import * as firebase from 'firebase/app';
// import 'firebase/auth';
import 'firebase/database';

import { AuthService } from '../auth/guard.service';

import { Subscription } from 'rxjs/Subscription';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import 'rxjs/add/operator/first';

import { IndexedSnap, SelectRequest, SelectRequestDir } from './Item.component';

import { Item } from '../types';

import { IndexedRef } from './NewItem.component';

import { DateUtils } from '../dateutils.service';

export interface IndexedSnapObs extends IndexedSnap {
    selectSubj : Subject<void>
}

export interface IndexedRefObs extends IndexedRef {
    selectSubj : Subject<void>
}

@Component({
    selector: 'list-for-date',
    templateUrl: './ListForDate.component.html',
    styleUrls: ['./ListForDate.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ListForDate implements OnInit, OnChanges, OnDestroy {

    @Input() date : Date

    public uid : string
    private authSubs : Subscription
    public itemsObservable : Observable<AngularFireAction<firebase.database.DataSnapshot>[]>

    constructor(public afDb : AngularFireDatabase, public auth : AuthService, private ch : ChangeDetectorRef, private dateutils : DateUtils) {}

    refreshItems() {
        if (!this.uid || !this.date) {
            return;
        }
        let path = "/items/" + this.uid + "/" + this.dateutils.formatDate(this.date);

        this.itemsObservable = this.afDb.list<Item>(path).snapshotChanges();
        this.ch.markForCheck();
    }

    ngOnInit() {
        this.authSubs = this.auth.user.subscribe(user => {
            if (user) {
                this.uid = user.uid;
                this.refreshItems();
            }
        });
    }

    ngOnDestroy() {
        if (this.authSubs) {
            this.authSubs.unsubscribe();
        }
    }

    ngOnChanges(changes: SimpleChanges) {
        this.refreshItems();
    }

}



// WEBPACK FOOTER //
// /Users/vlad/Projects/done/web/src/app/items/ListForDate.component.ts